export const ICON_CLASSES: string[] = [ 'fa', 'fa-exclamation-circle', 'negative' ];
export const TOOLTIP_CLASSES: string[] = [ 'mat-tooltip', 'error-state' ];
export const FIELD_CLASS: string = 'negative';
export const TEXT_CLASS: string = 'negative';

export class CssClasses {
    iconClasses: string[] = ICON_CLASSES;
    toolTipClasses: string[] = TOOLTIP_CLASSES;
    fieldClass: string = FIELD_CLASS;
    textClass: string = TEXT_CLASS;
}

export class PershingGridInlineMessage {
    constructor(public field: string, public errorType: MESSAGE_TYPE = MESSAGE_TYPE.ERROR,
                public message: string = 'Invalid value', public align: string = 'start') {}
}

export enum MESSAGE_TYPE {
    ERROR, WARNING, SUCCESS, INFO
}
